var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconVoucher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 6h22v6.21c-3.627 1.202-3.627 6.378 0 7.58V26h-22V6zm22.73 11.923a2 2 0 00.548.077h.722v8a2 2 0 01-2 2h-22a2 2 0 01-2-2V6a2 2 0 012-2h22a2 2 0 012 2v8h-.72c-.186 0-.37.026-.55.077-1.933.553-1.933 3.293 0 3.846zM20.5 20v4h2v-4h-2zm-3 0h-9v-2h9v2zm3-6v4h2v-4h-2zm-3 0h-9v-2h9v2zm3-6v4h2V8h-2z",
    fill: "#54822B"
  })));
}

export default SvgIconVoucher;